export const lightTheme = {
  bodyback: "#f1f1f1",
  bodydark: "#7c7c7c",
  body: "#FFF",
  text: "#363537",
  activetext: "#04DA9A",
  toggleBorder: "#FFF",
  background: "#363537",
  side_shadow: "0px 1px 23px #d4d4d4",
  sidebox_shadow: "3px 3px 3px #d4d4d4",
  graph_head: {
    bg: "#f1f1f1",
    border_bottom: "0.1px solid rgba(0, 0, 0, 0.1)",
  },
  pair_border: {
    b_top: "0.1px solid rgba(0,0,0,0.1)",
    b_bottom: "0.1px solid rgba(0,0,0,0.1)",
  },
  shead_bg: "white",
  shead_circle: "rgb(166 168 172)",
  buy_sell_form_bg: "white",
  buy_sell_theme: {
    b: "0.1px solid rgba(0,0,0,0.1)",
    c: "#848484",
  },
  low_price: {
    c: "#1ece3f",
    b: "0.1px solid rgba(0,0,0,0.1)",
  },
  high_price: {
    c: "#f85454",
    b: "0.1px solid rgba(0,0,0,0.1)",
  },
 g_color:{
   clr:"rgba(0,0,0,0.7)",
 }
};
export const darkTheme = {
  bodyback: "#141A28",
  bodydark: "#9b9b9b",
  activetext: "#04DA9A",
  body: "#1E2738",
  text: "#FAFAFA",
  toggleBorder: "#6B8096",
  background: "#999",
  side_shadow: "0px 1px 23px #333333",
  sidebox_shadow: "3px 3px 3px #333333",
  graph_head: {
    bg: "#1E2738",
    border_bottom: "0.1px solid rgb(199 199 199 / 10%)",
  },
  pair_border: {
    b_top: "0.1px solid #474747",
    b_bottom: "0.1px solid #474747",
  },
  shead_bg: "#333131",
  shead_circle: "rgb(18 18 19)",
  buy_sell_form_bg: "#474747",
  buy_sell_theme: {
    b: "0.1px solid rgba(0,0,0,0.1)",
    c: "darkgrey",
  },
  low_price: {
    c: "#1ece3f",
    b: "0.1px solid rgba(0,0,0,0.1)",
  },
  high_price: {
    c: "#f85454",
    b: "0.1px solid rgba(0,0,0,0.1)",
  },
  g_color:{
    clr:"white",
  }
};
